/** biome-ignore-all lint/suspicious/noExplicitAny: FIXME */
import type React from "react";
import { createContext, type FC, useContext } from "react";
import type { Manufacturer } from "./Manufacturer";

export const ManufacturerContext = createContext<Manufacturer<any, any> | null>(
  null,
);

interface ManufacturerProviderProps<
  ProductType extends string,
  PartType extends string,
> {
  children: React.ReactNode;
  manufacturer: Manufacturer<ProductType, PartType>;
}

export const ManufacturerProvider: FC<ManufacturerProviderProps<any, any>> = ({
  children,
  manufacturer,
}) => {
  return (
    <ManufacturerContext.Provider value={manufacturer}>
      {children}
    </ManufacturerContext.Provider>
  );
};

export const useManufacturer = <
  ProductType extends string,
  PartType extends string,
>(): Manufacturer<ProductType, PartType> => {
  const manufacturer = useContext(ManufacturerContext);
  if (!manufacturer) {
    throw new Error("Manufacturer not found");
  }
  return manufacturer;
};
